/**
 * Points of Interest Map Layer
 * @param map  the map instance
 * @param zoomErrorMessage  the zoomErrorMessage instance
 */
define(['bing', 'jquery', 'c21/maps', 'c21/track', 'image!/images/eco/idx/layout/poitexturesheet.png'], function (BingMaps, $, C21Maps, track, spriteSheet) {
   "use strict";

   return function (map, zoomErrorMessage) {
      var self = this,
         BingMaps = window.Microsoft.Maps,

         m_layer = new BingMaps.Layer(),
         m_iCounter = 0,
         m_map = map,
         m_tooltip,
         m_aClasses = [
            'Recreation',
            'Banks',
            'Food',
            'Education',
            'Government',
            'HealthCare',
            'PlacesOfWorship',
            'Services',
            'PetServices',
            'Shopping',
            'Travel'
         ],
         m_tooltipTemplate = [
            '<div style="position:relative;">',
            '<div style="background-color:#fff;padding:5px;">',
            '<b>{title}</b>',
            '</div>',
            '</div>'].join(''),
         m_zoomErrorMessage = zoomErrorMessage,

         initialize = function () {
            m_layer.setZIndex(3);
            m_map.layers.insert(m_layer);

            //Create an infobox to use as a tooltip when hovering.
            m_tooltip = new BingMaps.Infobox(map.getCenter(), {
               visible: false,
               showPointer: false,
               showCloseButton: false,
               offset: new BingMaps.Point(0, 13)
            });

            m_tooltip.setMap(m_map);
         };

      function getPoiImageByName (strName) {
         var index = m_aClasses.indexOf(strName);
         var c = document.createElement('canvas');
         var ctx = c.getContext('2d');
         var iconHeight = 16;
         var iconWidth = 18;
         c.height = 16;
         c.width = 16;
         ctx.drawImage(spriteSheet, index * iconWidth, 0, iconWidth, iconHeight, 0, 0, iconWidth, iconHeight);
         return c.toDataURL();
      }

      initialize();

      self.addPushPin = function (aLocation, sClass, sLabel) {
         m_iCounter++;
         var pin = new BingMaps.Pushpin(aLocation, {
            height: 16,
            width: 16,
            anchor: new BingMaps.Point(8, 8),
            icon: getPoiImageByName(sClass)
         });
         m_layer.add(pin);

         BingMaps.Events.addHandler(pin, 'mouseover', function () {
            m_tooltip.setOptions({
               location: pin.getLocation(),
               htmlContent: m_tooltipTemplate.replace('{title}', sLabel),
               visible: true
            });
         });

         BingMaps.Events.addHandler(pin, 'mouseout', function () {
            m_tooltip.setOptions({
               visible: false
            });
         });

         C21Maps.onPinHoverIntent(m_map, pin, function () {
            track.doEvent('Hybrid Mapping', 'Points of Interest Map', 'Hover over a point of interest on the map');
         }, function () {}
            );

         BingMaps.Events.addHandler(pin, 'click', function (e) {
            track.doEvent('Hybrid Mapping', 'Points of Interest Map', 'Click on a point of interest on the map');
         });
      };

      self.clearPOI = function () {
         m_layer.clear();
      };

      self.render = function (sTypes) {
         if (sTypes && sTypes.length > 0) {
            var bounds = m_map.getBounds(),
               oParams = {
                  xy: bounds.getNorth().toString(),
                  mx: bounds.getWest().toString(),
                  my: bounds.getSouth().toString(),
                  xx: bounds.getEast().toString(),
                  submitted: 'true',
                  ct: sTypes,
                  subView: 'PointsOfInterestSearch'
               };

            $.ajax({
               dataType: "json",
               data: oParams,
               url: "/poi/?",
               success: function (data) {
                  var locations = data.locations;

                  self.clearPOI();

                  if (locations.length > 999) {
                     // NOTE: POI is already limited by zoom level
                     m_zoomErrorMessage.enable('poi');
                     return;
                  }

                  m_zoomErrorMessage.disable('poi');

                  $.each(locations, function (i, location) {
                     var loc = new BingMaps.Location(location.latitude, location.longitude),
                        cls = location.type.toLowerCase().replace(/((^| )[a-z])/g, function ($1) {
                           return $.trim($1.toUpperCase());
                        }).split(' ')[0];

                     self.addPushPin(loc, cls, location.name.replace("&amp;", "&") + (location.phone ? '   Phone: ' + location.phone : ''));
                  });
               }
            });
         } else {
            self.clearPOI();
         }
      };
   };
});
